import { RouteRecordRaw } from 'vue-router'

const auditPatient: Array<RouteRecordRaw> = [{
    path: '/audit-patient',
    meta: {
        title: "患者审核"
    },
    component: () => import("@/views/audit-patient/list.vue")
}];
export default auditPatient;